module.exports = __webpack_public_path__ + "img/changing.c109707a.gif";